// extracted by mini-css-extract-plugin
export default {"searchBar":"Navigation_searchBar__d-stG","mobileSocialMedia":"Navigation_mobileSocialMedia__U0Ipl"};